export enum Zone {
  "us-e" = "us-e",
  "us-w" = "us-w",
  eu = "eu",
  ap = "ap",
  au = "au",
  sa = "sa",
  af = "af",
  me = "me",
  cn = "cn",
  jp = "jp",
  in = "in",
  kr = "kr",
}
export const ZONES = [
  Zone["us-e"],
  Zone["us-w"],
  Zone["eu"],
  Zone["ap"],
  Zone["au"],
  Zone["sa"],
  Zone["af"],
  Zone["me"],
  Zone["cn"],
  Zone["jp"],
  Zone["in"],
  Zone["kr"],
]
